module.exports = __webpack_public_path__ + "static/media/황금산.f88d56b9.jpg";